import { render } from "./PromotionQuestion.vue?vue&type=template&id=44bbe59a"
import script from "./PromotionQuestion.vue?vue&type=script&lang=js"
export * from "./PromotionQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__